import XCircleIcon from "@heroicons/react/20/solid/XCircleIcon";

import { type StepName as Step } from "@hsl/fc-subscription/types";

import { Translate } from "../../../hooks/useTranslation";

interface Props {
    step: Step;
    steps: Step[];
    error?: string;
    children: (props: { step: Step }) => React.ReactNode;
}

export const FlowStep = ({ step, steps, error, children }: Props) => {
    const thisIdx = steps.findIndex((s) => s === step);
    if (thisIdx === -1) {
        return (
            <>
                <Translate>Invalid step</Translate>
            </>
        );
    }
    return (
        <div className="flex flex-col gap-4">
            {typeof children === "function" ? (
                <>{children({ step })}</>
            ) : (
                children
            )}

            {error && (
                <div className="text-core-red my-2 flex max-w-sm items-start gap-2 self-end">
                    <XCircleIcon width={20} className="mt-0.5 shrink-0" />
                    <p>
                        <Translate>{error}</Translate>
                    </p>
                </div>
            )}
        </div>
    );
};
